import { lazy } from 'react';

const Merchant = lazy(() => import('./MerchantPage'));

const MerchantConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'merchant/login',
      element: <Merchant />,
    },
  ],
};

export default MerchantConfig;
